var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "alpheios-feature-options__cont" },
    [
      _c("setting", {
        staticClass: "alpheios-feature-options__item",
        attrs: { data: _vm.featureOptions.items.preferredLanguage },
        on: { change: _vm.featureOptionChanged },
      }),
      _vm._v(" "),
      _c(
        "fieldset",
        { staticClass: "alpheios-feature-options__cont-concord" },
        [
          _c("legend", [
            _vm._v(_vm._s(_vm.l10n.getText("LABEL_FIELDSET_USAGEEXAMPLES"))),
          ]),
          _vm._v(" "),
          _c("setting", {
            staticClass: "alpheios-feature-options__item",
            attrs: { data: _vm.featureOptions.items.enableWordUsageExamples },
            on: { change: _vm.featureOptionChanged },
          }),
          _vm._v(" "),
          _c("setting", {
            staticClass: "alpheios-feature-options__item",
            attrs: { data: _vm.featureOptions.items.wordUsageExamplesON },
            on: { change: _vm.featureOptionChanged },
          }),
          _vm._v(" "),
          _c("setting", {
            staticClass: "alpheios-feature-options__item",
            attrs: { data: _vm.featureOptions.items.wordUsageExamplesAuthMax },
            on: { change: _vm.featureOptionChanged },
          }),
          _vm._v(" "),
          _c("setting", {
            staticClass: "alpheios-feature-options__item",
            attrs: { data: _vm.featureOptions.items.wordUsageExamplesMax },
            on: { change: _vm.featureOptionChanged },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("setting", {
        staticClass: "alpheios-feature-options__item",
        attrs: { data: _vm.featureOptions.items.enableLemmaTranslations },
        on: { change: _vm.featureOptionChanged },
      }),
      _vm._v(" "),
      _c("setting", {
        staticClass: "alpheios-feature-options__item",
        attrs: { data: _vm.featureOptions.items.locale },
        on: { change: _vm.featureOptionChanged },
      }),
      _vm._v(" "),
      _c(
        "fieldset",
        { staticClass: "alpheios-ui-options__cont-wordselect" },
        [
          _c("legend", [
            _vm._v(_vm._s(_vm.l10n.getText("LABEL_FIELDSET_WORDSELECT"))),
          ]),
          _vm._v(" "),
          _c("setting", {
            staticClass: "alpheios-feature-options__item",
            attrs: {
              data: _vm.featureOptions.items.enableMouseMove,
              selectedOverride: _vm.mouseMoveChecked,
            },
            on: {
              change: _vm.featureOptionChanged,
              clearSelectedOverride: _vm.clearMouseMoveOverride,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("setting", {
        staticClass: "alpheios-feature-options__item",
        attrs: { data: _vm.featureOptions.items.wordlistMaxFlashcardExport },
        on: { change: _vm.featureOptionChanged },
      }),
      _vm._v(" "),
      _c(
        "fieldset",
        { staticClass: "alpheios-ui-options__cont-wordselect" },
        [
          _c("legend", [
            _vm._v(_vm._s(_vm.l10n.getText("LABEL_FIELDSET_BETACODES"))),
          ]),
          _vm._v(" "),
          _c("setting", {
            staticClass: "alpheios-feature-options__item",
            attrs: { data: _vm.featureOptions.items.useBetaCodes },
            on: { change: _vm.featureOptionChanged },
          }),
          _vm._v(" "),
          _c("setting", {
            staticClass: "alpheios-feature-options__item",
            attrs: { data: _vm.featureOptions.items.showBetaCodesInfo },
            on: { change: _vm.featureOptionChanged },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("setting", {
        staticClass: "alpheios-feature-options__item",
        attrs: { data: _vm.featureOptions.items.enableLogeionAutoComplete },
        on: { change: _vm.featureOptionChanged },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }